

window.Zretel or= {}

class window.Zretel.Training

  @templateLoading = false

  @refreshDeliveryForms: () ->
    $('.training-delivery-form').each ->
      field = $(this)
      scope = field.closest('.training-fieldset')
      scope = field.closest('form') unless scope.length
      online = field.val() in ['online', 'combined_online_elearning']
      scope.find('select.place').closest('.form-group').prop('hidden', online)
      scope.find('.training-web-place-note').prop('hidden', field.val() not in ['onsite', 'combined', 'combined_online_onsite', 'combined_elearning_onsite'])
      explicitCombined = field.val() in ['combined_online_onsite', 'combined_elearning_onsite', 'combined_online_elearning']
      scope.find('.training-legacy-note-hint').prop('hidden', explicitCombined)
      scope.find('.training-combined-note-hint').prop('hidden', !explicitCombined)


  @form: () ->
    form = $('.training-slug-field').first().closest('form')
    return form if form.length > 0

    $('form').first()

  @refreshSubmitButtons: () ->
    disabled = window.Zretel.Training.templateLoading
    window.Zretel.Training.form().find('input[type="submit"], button[type="submit"]').prop('disabled', disabled)

  @normalizeSlugValue: (slug) ->
    slug.toString().trim().toLowerCase()

  @slugifyValue: (value) ->
    value.toString().trim().toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')

  @formatSlugDate: (value) ->
    match = value.toString().trim().match(/^(\d{1,2})\D(\d{1,2})\D(\d{4})$/)
    return '' unless match?

    day = match[1].padStart(2, '0')
    month = match[2].padStart(2, '0')
    year = match[3]
    "#{day}-#{month}-#{year}"

  @generatedSlugSuffix: (fieldset) ->
    fieldset = $(fieldset)
    placeField = fieldset.find('.place').first()
    dateField = fieldset.find('input[name*="[date_from]"]').first()
    placeCities = placeField.data('placeCities') || {}
    city = placeCities[placeField.val()]
    deliveryForm = fieldset.find('.training-delivery-form').val()
    if deliveryForm == 'online'
      city = 'ONLINE'
    else if deliveryForm == 'combined_online_elearning'
      city = 'ONLINE + e-learning'
    else if deliveryForm in ['onsite', 'combined', 'combined_online_onsite', 'combined_elearning_onsite']
      city = (placeField.data('physicalCities') || {})[placeField.val()]
      city = "ONLINE + #{city}" if deliveryForm in ['combined', 'combined_online_onsite'] && city
      city = "E-learning + #{city}" if deliveryForm == 'combined_elearning_onsite' && city
    formattedDate = window.Zretel.Training.formatSlugDate(dateField.val())
    normalizedCity = window.Zretel.Training.slugifyValue(city || '')
    return '' if normalizedCity.length == 0 || formattedDate.length == 0

    "-#{normalizedCity}-#{formattedDate}"

  @syncSlugBaseValue: (fieldset) ->
    fieldset = $(fieldset)
    slugField = fieldset.find('.training-slug-field').first()
    return unless slugField.length > 0

    suffix = window.Zretel.Training.generatedSlugSuffix(fieldset)
    slugValue = window.Zretel.Training.slugifyValue(slugField.val())
    if suffix.length > 0 && slugValue.endsWith(suffix)
      slugValue = slugValue.slice(0, -suffix.length)

    if suffix.length > 0
      slugValue = slugValue.replace(/-\d+$/, '')

    slugField.data('baseSlug', slugValue.replace(/-+$/g, ''))

  @refreshTrainingSlug: (fieldset) ->
    fieldset = $(fieldset)
    slugField = fieldset.find('.training-slug-field').first()
    return unless slugField.length > 0

    baseSlug = slugField.data('baseSlug') || slugField.data('initialSlug') || ''
    baseSlug = window.Zretel.Training.slugifyValue(baseSlug)
    return if baseSlug.length == 0

    suffix = window.Zretel.Training.generatedSlugSuffix(fieldset)
    if suffix.length > 0
      baseSlug = baseSlug.replace(/-\d+$/, '')

    slugField.val(baseSlug + suffix)

  @setSlugStatus: (slugField, message) ->
    slugField = $(slugField)
    slugStatus = slugField.closest('.form-group').find('.training-slug-status')

    slugField.removeClass('is-invalid')
    slugStatus.text('')
    slugStatus.removeClass('text-danger')

    return if message.length == 0

    slugField.addClass('is-invalid')
    slugStatus.text(message)
    slugStatus.addClass('text-danger')

  @clearSlugStatuses: (form) ->
    $(form).find('.training-slug-field').each ->
      window.Zretel.Training.setSlugStatus($(this), '')

  @validateUniqueNestedSlugs: (form) ->
    form = $(form)
    slugFieldsByValue = {}
    duplicateTargets = []

    window.Zretel.Training.clearSlugStatuses(form)

    form.find('.training-fieldset .training-slug-field').each ->
      slugField = $(this)
      normalizedSlug = window.Zretel.Training.normalizeSlugValue(slugField.val())
      return if normalizedSlug.length == 0

      slugFieldsByValue[normalizedSlug] ||= []
      slugFieldsByValue[normalizedSlug].push(slugField)

    duplicateSlugFields = Object.values(slugFieldsByValue).filter((slugFields) -> slugFields.length > 1)
    return true if duplicateSlugFields.length == 0

    duplicateSlugFields.forEach (slugFields) ->
      duplicateTargets.push(slugFields[1]) if slugFields.length > 1
      slugFields.forEach (slugField) ->
        window.Zretel.Training.setSlugStatus(slugField, 'URL musi byt unikatni v ramci vsech skoleni ve formulari')

    firstDuplicateTarget = $(duplicateTargets[0])
    if firstDuplicateTarget.length > 0
      firstDuplicateTarget[0].scrollIntoView({ behavior: 'smooth', block: 'center' })
      firstDuplicateTarget.trigger('focus')

    false

  @toggleTemplateSubmitButtons: (disabled) ->
    window.Zretel.Training.templateLoading = disabled
    window.Zretel.Training.refreshSubmitButtons()

  @nextSlugValue: (slug) ->
    normalizedSlug = slug.toString().trim().toLowerCase()
    return '' if normalizedSlug.length == 0

    match = normalizedSlug.match(/^(.*?)-(\d+)$/)
    return normalizedSlug + '-2' unless match?

    prefix = match[1]
    number = parseInt(match[2], 10)
    return normalizedSlug unless prefix.length > 0 && !isNaN(number)

    prefix + '-' + (number + 1)

  @slugParts: (slug) ->
    normalizedSlug = slug.toString().trim().toLowerCase()
    return null if normalizedSlug.length == 0

    match = normalizedSlug.match(/^(.*?)-(\d+)$/)
    return { base: normalizedSlug, index: 1 } unless match?

    base = match[1]
    index = parseInt(match[2], 10)
    return { base: normalizedSlug, index: 1 } unless base.length > 0 && !isNaN(index)

    { base: base, index: index }

  @nextNestedSlugValue: (slugFields) ->
    slugFields = $(slugFields)
    return '' if slugFields.length == 0

    firstSlugParts = null
    maxIndex = 1

    slugFields.each ->
      slugParts = window.Zretel.Training.slugParts($(this).val())
      return unless slugParts?

      firstSlugParts ||= slugParts
      maxIndex = Math.max(maxIndex, slugParts.index) if slugParts.base == firstSlugParts.base

    return '' unless firstSlugParts?
    return firstSlugParts.base + '-2' if maxIndex < 2

    firstSlugParts.base + '-' + (maxIndex + 1)

  @setNextNestedTrainingSlug: (insertedItem) ->
    insertedItem = $(insertedItem)
    fieldset = if insertedItem.hasClass('training-fieldset') then insertedItem else insertedItem.find('.training-fieldset').first()
    return unless fieldset.length > 0

    slugField = fieldset.find('.training-slug-field').first()
    return unless slugField.length > 0

    existingSlugField = fieldset.closest('form').find('.training-fieldset .training-slug-field').not(slugField).first()
    nextSlug = existingSlugField.data('baseSlug') || existingSlugField.data('initialSlug') || ''
    return if nextSlug.length == 0

    slugField.data('baseSlug', window.Zretel.Training.slugifyValue(nextSlug))
    window.Zretel.Training.refreshTrainingSlug(fieldset)

  @bindSlugFieldsetEvents: (fieldset) ->
    fieldset = $(fieldset)
    slugField = fieldset.find('.training-slug-field').first()
    placeField = fieldset.find('.place').first()
    dateField = fieldset.find('input[name*="[date_from]"]').first()

    slugField.off('.trainingSlugBuilder').on 'input.trainingSlugBuilder change.trainingSlugBuilder', ->
      currentFieldset = $(this).closest('.training-fieldset')
      window.Zretel.Training.syncSlugBaseValue(currentFieldset)
      window.Zretel.Training.refreshTrainingSlug(currentFieldset)

    placeField.off('.trainingSlugBuilder').on 'change.trainingSlugBuilder', ->
      currentFieldset = $(this).closest('.training-fieldset')
      window.Zretel.Training.refreshTrainingSlug(currentFieldset)

    dateField.off('.trainingSlugBuilder').on 'change.trainingSlugBuilder input.trainingSlugBuilder', ->
      currentFieldset = $(this).closest('.training-fieldset')
      window.Zretel.Training.refreshTrainingSlug(currentFieldset)

    window.Zretel.Training.syncSlugBaseValue(fieldset)
    window.Zretel.Training.refreshTrainingSlug(fieldset)

  @bindAllSlugFieldsets: () ->
    $('.training-fieldset').each ->
      window.Zretel.Training.bindSlugFieldsetEvents(this)

  @formEvents: () ->
    window.Zretel.Training.refreshDeliveryForms()
    $(document).off('change.trainingDelivery', '.training-delivery-form').on 'change.trainingDelivery', '.training-delivery-form', ->
      window.Zretel.Training.refreshDeliveryForms()
      scope = $(this).closest('.training-fieldset')
      scope = $(this).closest('form') unless scope.length
      scope.find('select.place').trigger('change')

    window.Zretel.Training.paymentTypeEvents()
    window.Zretel.Training.correspondenceEvents()
    #    window.Zretel.Training.employmentDepartmentEvents()
    window.Zretel.Training.templateName()
    window.Zretel.Training.templateAccreditation()
    window.Zretel.Training.nestedTrainingEvents()
    window.Zretel.Training.slugSubmitValidation()
    window.Zretel.Training.applicationIco()

    # Trigger change without clearing fields on page load
    window.Zretel.Training.initialPaymentTypeLoad = true
    $('.payment_type_radio').first().trigger('change')
    window.Zretel.Training.initialPaymentTypeLoad = false

  @nestedTrainingEvents: () ->
    window.Zretel.Training.bindAllSlugFieldsets()

    $(document).off('cocoon:after-insert.trainingSlug').on 'cocoon:after-insert.trainingSlug', (event, insertedItem) ->
      window.Zretel.Training.refreshDeliveryForms()
      window.Zretel.Training.setNextNestedTrainingSlug(insertedItem)
      window.Zretel.Training.bindSlugFieldsetEvents(insertedItem)

  @slugSubmitValidation: () ->
    window.Zretel.Training.form().off('submit.trainingSlugValidation').on 'submit.trainingSlugValidation', (event) ->
      return if window.Zretel.Training.validateUniqueNestedSlugs(this)

      event.preventDefault()
      event.stopImmediatePropagation()


  @templateName: () ->
    $('#training_template_name').off('change').on 'change', ->
      window.Zretel.Training.toggleTemplateSubmitButtons(true)
      $.ajax
        url: '/skoleni/template_form'
        method: 'GET'
        data:
          template_name: $(this).val()
        complete: ->
          window.Zretel.Training.toggleTemplateSubmitButtons(false)

  @templateAccreditation: () ->
    $('#training_template_accreditation').off('change').on 'change', ->
      window.Zretel.Training.toggleTemplateSubmitButtons(true)
      $.ajax
        url: '/skoleni/template_form'
        method: 'GET'
        data:
          template_accreditation: $(this).val()
          template_name: $('#training_template_name').val()
        complete: ->
          window.Zretel.Training.toggleTemplateSubmitButtons(false)

  @applicationIco: () ->
    $('input#training_application_ico').on 'change', ->
      $.ajax '/ares',
      type: 'POST'
      data:
        ico: $(this).val()

      if $(this).val == ''
        $('.form-group.training_repayment_type').removeClass('hidden')
      else
        $('.form-group.training_repayment_type').addClass('hidden')

  @correspondence: () ->
    if $('#training_application_different_addresses').prop('checked')
      $('#correspondence').removeClass('hidden')
    else
      $('#correspondence').addClass('hidden')
      $('#correspondence input').val('')

  @correspondenceEvents: () ->
    $('#training_application_different_addresses').on 'change', ->
      window.Zretel.Training.correspondence()

    window.Zretel.Training.correspondence()

  @updateFieldsIndex: () ->
    index = $('.training-fieldset').length.toString()
    $('.training-fieldset').attr('id', 'training-fieldset-' + index)
    $('.training-fieldset:last .place').attr("id", index + '_training_place')
    $('.training-fieldset:last .seo-title').attr("id", index + '_seo_title')
    $('.training-fieldset:last .seo-image').attr("id", index + '_seo_image')
    $('.training-fieldset:last .seo-image-preview').attr("id", index + '_seo_image_preview')

    $('#' + index + '_training_place').on 'change', ->
      $.ajax
        url: '/skoleni/update_seo_title'
        method: 'GET'
        data:
          index: index
          place_id: $(this).val()
          training_name: $(this).attr('training-name')
          delivery_form: $(this).closest('.training-fieldset').find('.training-delivery-form').val()


    return index

  @paymentTypeEvents: () ->
    $('.payment_type_radio').on 'change', ->
      if $('#training_application_payment_type_company').is(':checked')
        $('.form-group.company_field, #add-person, .address_field').removeClass('hidden')
        $('.employment_department_group').addClass('hidden')
        if $('#training_application_different_addresses').length > 0
          $('#training_application_different_addresses').prop('checked', true)
          $('#training_application_different_addresses').trigger('change')
          $('.different_addresses_wrapper').addClass('hidden')
        else
          $('#correspondence').addClass('hidden')
      else if $('#training_application_payment_type_self').is(':checked')
        $('.form-group.company_field, .employment_department_group, #add-person').addClass('hidden')
        $('.form-group.company_field, .employment_department_group, #add-person').val('')
        $('#training_application_email').val($('#training_application_application_people_attributes_0_email').val())
        $('#training_application_phone').val($('#training_application_application_people_attributes_0_phone').val())
        $('.address_field, .different_addresses_wrapper').removeClass('hidden')
        if $('#training_application_different_addresses').length > 0
          $('#training_application_different_addresses').prop('checked', false)
          window.Zretel.Training.correspondence()
        else
          $('#correspondence').addClass('hidden')
      else if $('#training_application_payment_type_employment_department').is(':checked')
        $('#correspondence').removeClass('hidden')
        $('.company_field, .address_field').addClass('hidden')
        $('.employment_department_group').removeClass('hidden')
        $('#add-person').addClass('hidden')
        if $('#training_application_different_addresses').length > 0
          $('#training_application_different_addresses').prop('checked', true)
          $('#training_application_different_addresses').trigger('change')
          $('.different_addresses_wrapper').addClass('hidden')

      console.log($(this))
      $.ajax
        url: '/skoleni/load_training_repayment_type'
        method: 'GET'
        data:
          training_id: $(this).attr('training_id')
          payment_type: $(this).val()

      # Only clear fields on actual user interaction, not on page load or form resubmission
      unless window.Zretel.Training.initialPaymentTypeLoad || $('#error_explanation').length > 0
        $('.address_field input, .company_field input, .employment_department_group input:not([type="radio"])').val('')
    # $('.payment_type_radio').first().trigger('change')

  @employmentDepartmentEvents: () ->
    $('.employment_department_type_radio').on 'change', ->
      if $('#training_application_employment_department_type_request').is(':checked')
        $('.employment_department_field').removeClass('hidden')
      else if $('#training_application_employment_department_type_approved').is(':checked')
        $('.employment_department_field').addClass('hidden')
        $('.employment_department_field input').val('')

  @publicFilterEvents: () ->
    $('.filter-select').each ->
      placeholder = $(this).attr('placeholder')
      $(this).selectpicker
        noneSelectedText: placeholder

    $('.filter-select').on 'changed.bs.select', ->
      window.Zretel.Training.submitPublicFilter($(this))

    $('.form-control[type="search"]').on 'change', ->
      window.Zretel.Training.submitPublicFilter($(this))

    $('#clear-filter').on 'click', (e) ->
      e.preventDefault()
      $('.form-control[type="search"]').val('')
      $('.filter-select').each ->
        $(this).selectpicker('deselectAll').selectpicker('refresh')
      window.Zretel.Training.submitPublicFilter($('#clear-filter'), true)

  @submitPublicFilter: (target, clear = false) ->
    form = target.closest('form')
    if clear
      form.find('select').each (index, element) ->
        $element = $(element)
        $element.val(null)
        $element.selectpicker('refresh')

    form.find('.btn[type="submit"]').trigger('click')
    $('#trainings').html('')
    $('.spinner').removeClass('hidden')




# $('.is_company_radio input').first().trigger("change")
